import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "react-axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { useUser } from "~/Context/userContext";
import { getTrackIsFavorite, setTrackFavorite } from "../../api/getTrack";

const FavoriteWrapper = styled.section`
  display: inline-block;
  .favorite-icon {
    font-size: 21px;
    margin-right: 6px;
  }
  &.icon-loading {
    opacity: 0.2;
  }
  .counter {
    font-size: 16px;
    line-height: 18px;
  }
  &:hover {
    cursor: pointer;
  }
`;

const TrackFavorite = ({ track, userFav }) => {
  const [fav, setFav] = useState(userFav);
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(parseInt(track.favs) || 0);
  let { state, dispatch } = useUser();

  React.useEffect(() => {
    if (!track.id || !state.loggedin) {
      return;
    }
    setLoading(false);
    getTrackIsFavorite(axios, track.id, { chim: state.user && state.user.dir }).then(({ data: { total, liked } }) => {
      setCount(total);
      setFav(Boolean(Number(liked)));
    });
  }, [state.user]);

  React.useEffect(() => {
    if (track.id && state.loaded) {
      setReady(true);
      return;
    }
  }, [state.loaded]);

  const toggleFav = () => {
    if (ready && !state.loggedin && track.id) {
      localStorage.setItem("login_track_fav", track.id);
      dispatch({ type: "signin_show_fav" });
      // faked since we cant set these values after login/register
      setCount(parseInt(count) + 1);
      setFav(true);
      return;
    }

    if (loading) return null;

    setLoading(true);
    setTrackFavorite(axios, track.id, { chim: state.user && state.user.dir }).then(({ data: { total, faved } }) => {
      setCount(total);
      setFav(Boolean(Number(faved)));
      setLoading(false);
    });
  };

  if (!track.id) {
    return null;
  }

  return (
    <React.Fragment>
      <FavoriteWrapper
        title={loading ? `Sign-in to add track to your favorites` : `Add track to favorites`}
        onClick={() => toggleFav()}
        className={`icon icon-favorite`}
      >
        <span className="favorite-icon">
          <FontAwesomeIcon icon={[fav ? "fas" : "far", "heart"]} />
        </span>
        <span className="counter">{count}</span>
      </FavoriteWrapper>
    </React.Fragment>
  );
};

TrackFavorite.propTypes = {
  track: PropTypes.object,
  userFav: PropTypes.bool,
};

TrackFavorite.defaultProps = {
  track: {},
  userFav: false,
};

export default TrackFavorite;
